function EncryptedData(userId, payload, encAesKey) {
  this.userId = userId;
  this.payload = payload;
  this.encAesKey = encAesKey;
}

export default EncryptedData;
